import React, { useState } from 'react';
import { Alert } from 'react-bootstrap';
import apiFetch from '../../../utils/apiFetch';
import { getSubclassesForClass } from '../../../shared/rules/subclasses/index.mjs';
import { ClassCard, Button } from '../common/HudPrimitives';

export default function SubclassChooser({ characterId, classId, classLevel, onSelected }) {
  const definitions = getSubclassesForClass(classId).filter(({ selectionLevel }) => selectionLevel <= classLevel);
  const [selected, setSelected] = useState(definitions[0]?.id || '');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const choose = async () => {
    setSaving(true); setError('');
    try {
      const response = await apiFetch(`/characters/${characterId}/classes/${classId}/subclass`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ subclassId: selected }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Subclass selection failed.');
      onSelected?.(data);
      window.dispatchEvent(new CustomEvent('realmtracker:subclass-selected', { detail: { ...data, characterId: String(characterId) } }));
    } catch (reason) { setError(reason.message); setSaving(false); }
  };
  return <div className="subclass-chooser" aria-label={`Choose ${classId} subclass`}>
    {error && <Alert variant="danger">{error}</Alert>}
    <div className="levelup-choice-grid">
      {definitions.map((definition) => <ClassCard type="button" key={definition.definitionId} selected={selected === definition.id} onClick={() => setSelected(definition.id)}>
        <strong>{definition.name}</strong><span>{definition.description}</span>
        {definition.features.filter(({ level }) => level === definition.selectionLevel).map((feature) => <small key={feature.id}>{feature.name}</small>)}
      </ClassCard>)}
    </div>
    <Button variant="primary" disabled={!selected || saving} onClick={choose}>{saving ? 'Saving…' : 'Choose Subclass'}</Button>
  </div>;
}

